module.exports = __webpack_public_path__ + "static/media/documents-portal-login.9241a5aa.svg";